export function sideNavigationSubmenuToggle() {
    const handleClick = (e) => {
        const target = e.target.closest(".side-navigation-drawer .submenu-toggle");
        if (target) {
            const submenu = target.parentElement.querySelector(".sub-menu");

            console.log(target.parentElement, "target.parentElement");

            target.parentElement.style.setProperty("--initial-height", `${submenu.scrollHeight}px`);
            target.parentElement.classList.toggle("opened");
        }
    }

    document.addEventListener("click", handleClick);
}